import clsx from 'clsx';
import React from 'react';
import { IconType } from 'react-icons';

export interface IconProps {
  color?: string;
  size?: string | number;
  isRotating?: boolean;
  style?: React.CSSProperties;
  className?: string;
  ariaHidden?: boolean;
}

export const createIconComponent = (Component: IconType) => {
  // eslint-disable-next-line react/display-name
  return ({ color, size, isRotating, style, className, ariaHidden = true }: IconProps) => {
    return (
      <Component
        color={color}
        size={size}
        style={style}
        className={clsx(className, isRotating && 'animate-spin')}
        aria-hidden={ariaHidden}
      />
    );
  };
};
